import angular from 'angular';
import { BroadcastingSoftware } from '../../../ng-services/livestreams/BroadcastingSoftware';
import { YoutubeSetupInterface } from '../../../ng-services/livestreams/YoutubeSetupInterface';
import {
    EntryIdentifier,
    LivestreamConfigurationService,
} from '../../../ng-services/livestreams/LivestreamConfiguration.service';
import { getYoutubeIdFromUrl, isValidYoutubeId } from '../../../services/youtube-util';

export class LivestreamWizardComponent {
    static $inject = ['LivestreamConfigurationService', 'MeetingService'];

    youtubeSetup: YoutubeSetupInterface;
    broadcastingSoftware = BroadcastingSoftware.tradersyard;

    open?: string;

    readonly modalInstance!: angular.ui.bootstrap.IModalInstanceService;

    resolve!: {
        entry: EntryIdentifier;
        meetingId: number;
    };

    constructor(
        private readonly livestreamConfigurationService: LivestreamConfigurationService,
        readonly meetingService: any
    ) {
        this.youtubeSetup = {
            streamUrl: '',
            streamKey: '', // todo: from localstorage
        };
    }

    $onInit() {
        // store youtube url
        this.livestreamConfigurationService.get(this.entry).then((v) => {
            this.youtubeSetup.streamUrl = isValidYoutubeId(v.stream_id) ? `https://youtu.be/${v.stream_id}` : '';
            this.youtubeSetup.streamKey = v.streamKey;
        });
    }

    get entry(): EntryIdentifier {
        return this.resolve.entry;
    }

    get isValid() {
        return this.broadcastingSoftware && this.youtubeSetup?.streamKey;
    }

    closeAll() {
        this.open = undefined;
    }

    get isUsingYoutube() {
        return this.broadcastingSoftware === BroadcastingSoftware.youtube;
    }

    get isUsingTY() {
        return this.broadcastingSoftware === BroadcastingSoftware.tradersyard;
    }

    get validationMessage() {
        if (!this.youtubeSetup?.streamKey) {
            return 'Stream Key is required';
        }

        return '';
    }

    onYoutubeSetupChange(setup: YoutubeSetupInterface) {
        this.youtubeSetup = setup;
        // store youtube url
        this.livestreamConfigurationService.store(this.entry, {
            streamId: getYoutubeIdFromUrl(this.youtubeSetup.streamUrl || ''),
            streamKey: this.youtubeSetup.streamKey,
        });
    }

    submit() {
        if (!this.isValid) {
            return;
        }

        switch (this.broadcastingSoftware) {
            case BroadcastingSoftware.tradersyard:
                const meetingId = this.resolve.meetingId;
                // TODO: pass streaming key here? Right now we grab it from global scope deeper.
                this.meetingService.openVideoConferencePopup(meetingId);
                break;
            case BroadcastingSoftware.youtube:
                window.open('https://www.youtube.com/live_dashboard', '_blank');
                break;
        }

        this.modalInstance.close();
    }

    get submitButtonClassName() {
        return !this.isValid ? 'disabled' : '';
    }
}

angular.module('tradersyard').component('tyLivestreamWizard', {
    // language=HTML
    template: `
        <div class="modal-header">
            <h1>Start Live Streaming</h1>
            <h5>Broadcast on TradersYard via <strong>YouTube</strong> live streaming.</h5>
        </div>
        <div class="modal-body">

            <ty-livestream-setup-youtube-component
                value="$ctrl.youtubeSetup"
                open="$ctrl.open === 'youtube-setup'"
                on-close="$ctrl.closeAll()"
                on-open="$ctrl.open='youtube-setup'"
                on-change="$ctrl.onYoutubeSetupChange(value)"
            />

            <ty-livestream-setup-broadcasting-software-component
                selected="$ctrl.broadcastingSoftware"
                on-select="$ctrl.broadcastingSoftware = name"
                open="$ctrl.open === 'broadcasting-software-setup'"
                on-close="$ctrl.closeAll()"
                on-open="$ctrl.open='broadcasting-software-setup'"
            />

            <div class="clearfix">
                <div class="pull-left">
                    <div class="btn btn-link" ng-click="$ctrl.modalInstance.close()">Cancel</div>
                </div>
                <div class="pull-right">
                    <button class="btn btn-red" ng-class="$ctrl.submitButtonClassName" uib-tooltip="{{$ctrl.validationMessage}}" ng-if="$ctrl.isUsingYoutube" ng-click="$ctrl.submit($event)">
                        <i class="fab fa-youtube"></i> Open YouTube Studio
                    </button>
                    <button class="btn btn-red" ng-class="$ctrl.submitButtonClassName" uib-tooltip="{{$ctrl.validationMessage}}" ng-if="$ctrl.isUsingTY" ng-click="$ctrl.submit($event)">
                        <i class="fa fa-broadcast-tower"></i> Open Tradersyard Live
                    </button>
                </div>
            </div>

        </div>
    `,
    controller: LivestreamWizardComponent,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
